import React from 'react';

import { HN_SKJEMA_FRONTEND_RESOURCES } from 'src/constants/constants';
import { useRedirectVeilederData } from 'src/hooks/useRedirectVeilederData';
import { useResources } from 'src/resources';
import { redirectTilInnsendtSkjema, redirectTilLagretSkjemaPaaDokumenter } from 'src/store/actions/actionUtils';
import { useAppDispatch, useAppSelector } from 'src/store/reducers';
import { closeConfirmationLightbox } from 'src/store/reducers/uiSlice';

import type { HNSkjemaFrontend } from 'src/types/Resources';

import Modal from '@helsenorge/designsystem-react/components/Modal';

export type Props = {
  erKopiLagret: boolean;
  pdfFalseOgIkkeRecipient: boolean;
};

const ConfirmationLightbox = ({ erKopiLagret, pdfFalseOgIkkeRecipient }: Props): React.JSX.Element | null => {
  const resources = useResources<HNSkjemaFrontend>(HN_SKJEMA_FRONTEND_RESOURCES);
  const skjemaSendtInn = useAppSelector(state => state.refero.ui.skjemaSendtInn);
  const samtaleGuid = useAppSelector(state => state.refero.ui.samtaleGuid);
  const dokumentGuid = useAppSelector(state => state.refero.ui.dokumentGuid);
  const isSavedInDokumenter = useAppSelector(state => state.refero.ui.isSavedInDokumenter);
  const isMicrowebOppgave = useAppSelector(state => state.microweb.isMicrowebOppgave);
  const redirectVeilederData = useRedirectVeilederData();
  const dispatch = useAppDispatch();

  const getDescription = (): string | undefined => {
    if (pdfFalseOgIkkeRecipient || erKopiLagret) {
      return resources?.confirmation_skjemaoppgave_sent;
    }
    return resources?.sendtConfirmationDiscretion;
  };

  const handleOkButtonClick = (): void => {
    if (isMicrowebOppgave) {
      window.location.reload();
    } else {
      const redirect = redirectVeilederData(() => {
        if (isSavedInDokumenter) {
          redirectTilLagretSkjemaPaaDokumenter(dokumentGuid);
        } else {
          redirectTilInnsendtSkjema(samtaleGuid as string);
        }
      });
      if (!redirect) {
        dispatch(closeConfirmationLightbox());
      }
    }
  };

  return skjemaSendtInn && samtaleGuid && resources ? (
    <Modal
      testId="confirmation-lightbox"
      title={resources.sendtConfirmation}
      description={getDescription()}
      onSuccess={handleOkButtonClick}
      noCloseButton
    />
  ) : null;
};

export default ConfirmationLightbox;
